import React from "react";
import Theme from "../../theme.module.css";
import Style from "./CallToAction.module.css";

export default function CallToAction({text, setModalOpen}) {

    return (
        <div className={Style.callToAction}>
            <p>{text}</p>
            <a className={Theme.greenButton} onClick={() => setModalOpen('contact-form')}>contact us</a>
        </div>
    );
}